export const linkTemplate = () => '';
